//This FILE handle site wide navbar functionaly.. home navbarspecific funcionality is in home javascript files
$(document).on("DOMContentLoaded", function() { //turbolinks:load
  $("#select-language-link .nav-link").on("tap click", (e) => {
    $("#languages-bubble-wrapper").toggle();
    $("#user-menu-bubble-wrapper").hide();
    return false; //prevent propagation or otherwise it other events would also close the bubble immediately
  });

  $("#languages-bubble").on("tap click", e => {
    //stop event if we click inside bubble.. other wise next callbacks would close it
    if (e.target.nodeName !== "A") return false;
  });

  $('.facebook-page-link').on("tap click", e => {
    const isMobileOrTablet = window.matchMedia("only screen and (max-width: 992px)").matches;
    const isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    const pageId = 696752327165376

    if (isMobileOrTablet) {
      // setTimeout(function () { window.location = `https://www.facebook.com/NaVyletcz-696752327165376/`; }, 25); //toto som mal ako fallback
      if (isiOS) {
        window.location = `fb://profile/${pageId}`;
      } else {
        window.location = `fb://page/${pageId}`;
        //window.location = `fb://facewebmodal/f?href=https%3A%2F%2Fwww.facebook.com%2FNaVyletcz-696752327165376`;
      }
    } else {
      window.location = `https://www.facebook.com/NaVyletcz-696752327165376/`;
    }
  })

  $("#user-menu-link .nav-link").on("tap click", e => {
    $("#user-menu-bubble-wrapper").toggle();
    $("#languages-bubble-wrapper").hide();
    return false; //prevent propagation or otherwise it other events would also close the bubble immediately
  });

  $("#user-menu-bubble").on("tap click", e => {
    //stop event if we click inside bubble.. other wise next callbacks would close it
    if (e.target.nodeName !== "A") return false;
  });

  $("#favourited-attractions-summary").on("click", e => {
    window.location.assign(FAVOURITES.summaryPagePath()); //Turbolinks.visit
  });

  $(window).on("scroll", e => {
    $("#languages-bubble-wrapper").hide();
    $("#user-menu-bubble-wrapper").hide();
  });

  $("body").on("tap click", e => {
    $("#languages-bubble-wrapper").hide();
    $("#user-menu-bubble-wrapper").hide();
    if (
      !e.target.parentNode || !e.target.parentNode.classList.contains("location-search-input-wrapper")
    ) {
      $("#navbar-search-input").blur();
    }
  });
});
